const customStyles_v2 = {
  control: (provided) => ({
    ...provided,
    fontSize: "13px",
    minHeight: '36.5px',
    height: '36.5px',
    borderRadius: '16px',
    border: 'none', // ❌ quitar borde
    boxShadow: '0 .125rem .25rem rgba(0, 0, 0, .075)', // ✅ equivalente a shadow-sm
    '&:hover': {
      border: 'none', // mantener sin borde al hacer hover
      boxShadow: '0 .125rem .25rem rgba(0, 0, 0, .075)',
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '37.5px',
    padding: '0 6px',
  }),
  input: (provided) => ({
    ...provided,
    margin: '0',
    padding: '0',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '37.5px',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    padding: '0 6px',
  }),
  clearIndicator: (provided) => ({
    ...provided,
    padding: '0 6px',
  }),
  option: (provided) => ({
    ...provided,
    fontSize: '13px',
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: '6px',
  }),
};

export default customStyles_v2;
